import axios from 'axios'
import qs from 'qs'
import store from "../store/index";
import { Toast} from 'antd-mobile';
import {isBlank,isNotBlank} from "../util/StringUtil";
import { useHistory } from "react-router-dom";

 const ajaxUrl = 'https://www.jlszhgh.com/';
//const ajaxUrl = 'http://192.168.3.38/';
//const ajaxUrl = 'http://www.jlszhgh.com:8080/';
const imgUrl = ajaxUrl + 'download?url=';

let appParam = new FormData();
axios.defaults.headers['Accept'] = 'application/json, text/plain, */*'
axios.defaults.headers['Content-Type'] = 'application/json'; // 设置默认的请求头的Conte
//axios.defaults.headers['authorization'] = '1eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzb3VyY2UiOiJXRUIiLCJleHAiOjE2MzU0NzMyNDMsInVzZXJJZCI6IjJjOWNhMzc5NzYzZGQ5YjYwMTc2NDVmZDZmZDUwMDkyIn0.rW5SfCNfTBI3F24WGHWkB3oPZkp750mWnvmg8HNhsQI'
/**get
 * @description 封装的get请求的方法
 * @param {*} url 请求的地址
 * @param {*} data  请求的数据
 * @returns 数据请求的promise对象
 */
function getRequest(url, data) {
    getLocalStorageToken()

    let requestUrl = '/goodNetizen' + url;
    appParam.forEach((val, key) => {
        data[key] = val;
    });
    return axios.get(requestUrl, {
        params: data
    })
}

/**post
 * @description 封装post请求的方法
 * @param {*} url 请求的地址
 * @param {*} data 请求的数据
 * @returns 数据请求的promise对象
 */
function postRequest(url, data) {
    getLocalStorageToken()

    let requestUrl = '/goodNetizen' + url;
    console.log(requestUrl, data);
    return axios.post(requestUrl, data)
}

function getLocalStorageToken(){
    if(isBlank( axios.defaults.headers['authorization'])){
        const token = localStorage.getItem('token');
        axios.defaults.headers['authorization'] = token;
    }
}




function  uploadRequest(url, data) {
    getLocalStorageToken()

    let requestUrl = '/goodNetizen' + url;
    let param = new FormData(); // 创建form对象
    param.append("file", data); // 通过append向form对象添加数据

   // param.append("chunk", "别的数据"); // 添加form表单中其他数据
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
    };
    return axios.post(requestUrl, param,config)
}



// 请求拦截器
axios.interceptors.request.use(config => {

    store.dispatch({
        type: 'RouterLoading/get_router_loading',
        data: 0
    })
    return config
})

// 响应拦截器
axios.interceptors.response.use(async response => {


    store.dispatch({
        type: 'RouterLoading/get_router_loading',
        data: 1
    })
    if (!response) {
        Toast.show('请求异常');
        return;
    }
    if (response && response.status !== 200) {
        Toast.show(`接口异常  - ${response.status}`)
        return axios
    }
    const data = await response.data;
    if (!data) {
        Toast.show('请求异常');
        return;
    }
    if (!data.succeed) {
        if (data.errorMessage === '效验登录用户信息失败' || data.errorMessage === '用户已在其它位置登陆！'|| data.errorMessage === '获取用户信息失败') {
           // Toast.show('请重新登录');
            //let history = useHistory();
            //console.log('history',history);
            //useHistory.push('/login')
        }
        Toast.show(data.data && (data.data.ErrMsg || data.data.Message) || data.errorMessage)
    }

    return data
})

function setAuthToken(authToken){
    console.log('authToken',authToken)
    axios.defaults.headers['authorization'] = authToken
    localStorage.setItem('token',authToken);
}
function setRequestAuthtoken(params) {
    return new Promise(function (res, req) {
        console.log('params',params)
        const searchs = params.split('&');

            searchs.map(item =>{
                const valArr = item.split('=');
                if(valArr.length === 2){
                    appParam.append(valArr[0], valArr[1]);
                }
                if(valArr.length === 2&&valArr[0] === 'token'){
                    axios.defaults.headers['authorization'] = valArr[1]
                    localStorage.setItem('token',valArr[1]);
                }
            })

        res({ 'errcode': '200'})
    })
}

export default {
    // ...url,
    postRequest,
    getRequest,
    uploadRequest,
    setRequestAuthtoken,
    setAuthToken,
    imgUrl
}
